import { Box, Typography } from '@mui/material'

import type { BidDirection } from '@/features/bidding/types/bidLadderInput'

type BidLadderTotalMWProps = {
  totalMW: number
  /** Direction for styling. When omitted, uses neutral/symmetrical styling. */
  direction?: BidDirection
  /** Additional MW from preview (drag hover) */
  previewMW?: number
}

function BidLadderTotalMW({ totalMW, direction, previewMW = 0 }: Readonly<BidLadderTotalMWProps>) {
  // When direction is omitted (symmetrical), use neutral styling
  const isSymmetrical = direction === undefined

  const getColor = () => {
    if (isSymmetrical) return 'text.secondary'
    return direction === 'up' ? 'success.main' : 'error.main'
  }
  const color = getColor()

  const getAlign = () => {
    if (isSymmetrical) return 'center'
    return direction === 'up' ? 'left' : 'right'
  }
  const align = getAlign()

  const hasPreview = previewMW > 0
  const displayTotal = totalMW + previewMW

  return (
    <Box
      sx={{
        minWidth: 32,
        textAlign: align,
        mx: 0.5,
        px: 0.5,
        py: 0.25,
        backgroundColor: hasPreview ? 'action.hover' : 'transparent',
        borderRadius: '3px',
        transition: 'background-color 0.15s ease',
      }}
    >
      <Typography
        sx={{
          fontSize: '0.75rem',
          fontWeight: 600,
          fontVariantNumeric: 'tabular-nums',
          color: hasPreview ? 'primary.main' : color,
          opacity: hasPreview ? 0.9 : 1,
        }}
        variant="caption"
      >
        {displayTotal > 0 ? `${displayTotal.toFixed(0)}` : '-'}
      </Typography>
    </Box>
  )
}

export default BidLadderTotalMW
